<template>
    <div id="full">
      <div class="full_botton" @click="full_botton"></div>
      <div class="full_list">
        <div class="full_cont">
          <div class="fTop">
            <div class="full_xx" @click="full_xx"></div>
          </div>
          <ul>
            <li>
              <p>创源客服1</p><img src="http://wpa.qq.com/pa?p=2:3030519647:51"
                onclick="javascript:window.open(' http://wpa.qq.com/msgrd?v=3&uin=3030519647&site=qq&menu=yes');"
                onerror="this.src='image/pa.gif'" />
            </li>
            <li>
              <p>创源客服2</p><img src="http://wpa.qq.com/pa?p=2:43815119:51"
                onclick="javascript:window.open(' http://wpa.qq.com/msgrd?v=3&uin=43815119&site=qq&menu=yes');"
                onerror="this.src='image/pa.gif'" />
            </li>
            <li>
              <p>创源客服3</p><img src="http://wpa.qq.com/pa?p=2:724341068:51"
                onclick="javascript:window.open(' http://wpa.qq.com/msgrd?v=3&uin=724341068&site=qq&menu=yes');"
                onerror="this.src='image/pa.gif'" />
            </li>

          </ul>
          <div class="fButtom"></div>
        </div>
      </div>
    </div>
</template>
<script>
export default{
    name:'full',
    methods:{
        full_botton(){
            // 检查当前的right值
		    var currentRight = parseInt($('#full').css('right'), 10);
		
		    // 根据当前位置决定目标位置
		    var targetRight = currentRight === 10 ? '-128px' : '10px';
		
		    // 执行动画到新的位置
		    $('#full').animate({
		        right: targetRight
		    }, 500);  // 动画持续时间，3000毫秒即3秒
            
        },
        full_xx(){
	        $('#full').animate({
	            right: '-128px'
	        }, 400);
        }
    }
}
</script>
<style>
</style>